export interface AuthUserInterface {
  createdAt: string;
  deviceId: string;
  disabledAt: string;
  email: string;
  id: number;
  name: string;
  provider: string;
  providerId: string;
  refreshToken: string;
  resno: string;
  subjectId: string;
  updatedAt: string;
  picture?: string;
}

// export interface AuthUserInterface {
//   authResno: string;
//   familyName: string;
//   givenName: string;
//   isOriginal?: boolean;
//   username: string;
//   subjectId: string;
// }

interface EmployeeRelatedValues {
  dateFrom: string;
  dateTo: string;
  description: string;
  employeeRelatedValueId: number;
  percentage: number;
  personId: string;
  relatedValue: string;
  relationGroup: string;
  relationId: string;
  relationName: string;
  status: string;
}

interface EmployeeAdditionalInformation {
  employeeAdditionalInformationId: number;
  hasOvertime: boolean;
  isHourlyPaid: boolean;
  payYear: number;
  personId: string;
  relatedPersonId: string;
  startDate: string;
}

interface EmployeeNameInformation {
  aliasName: string;
  employeeNameInformationId: number;
  firstName: string;
  personId: string;
  surname: string;
  title?: string;
}

export interface EmployeeInterface {
  birthDate: string;
  camLocation: string;
  costCategory: string;
  dateFrom: string;
  dateTo: string;
  defaultWorkOrder: string;
  directClock: boolean;
  givenName: string;
  familyName: string;
  hasOvertime: boolean;
  holidayEligibility: string;
  homeState: string;
  incomeCategory: string;
  isTimeClockUser: boolean;
  otherResno: string;
  payGroup: string;
  personId: string;
  personalType: string;
  splitResno: number;
  resourceType: string;
  sickTimeEligibility: string;
  status: string;
  vacationEligibility: string;
  vacationBalance: number;
  sickTimeBalance: number;
  averageHours: number;
  userConfiguration: null | object;
}

export interface EntityInterface extends EmployeeInterface {
  subjectId?: string;
  timestamp: number;
  user: AuthUserInterface;
}

export interface UbwUserInterface {
  authResno: string;
  averageHours: number;
  benefitsBusinessUnit: string;
  benefitsCostCenter: string;
  // benefitsProject: string;
  benefitsResno: string;
  camResno: string;
  dateFrom: string;
  dateTo: string;
  defaultWorkOrder: string;
  directClock: boolean;
  familyName: string;
  givenName: string;
  // holidayEligibility: string;
  // isAllocated: boolean;
  isOriginal?: boolean;
  isTimeClockUser: boolean;
  lastPunch: null | object;
  location: string;
  sickTimeBalance: number;
  sickTimeEligibility: string;
  subjectId: string;
  tgsResno: string;
  timeStamp: number;
  userConfiguration: null | object;
  vacationBalance: number;
  vacationEligibility: string;
}

export enum AppMode {
  App = 'app',
  Kiosk = 'kiosk',
}

export interface PunchTypesInterface {
  name: string;
  value: string;
  disabled: boolean;
}

export interface PunchInterface {
  id: number;
  clientId: number;
  punchType: string;
  periodNumber: number;
  businessUnit: string;
  costCenter: string;
  projectId: string;
  inDateTime: string;
  inTimeSource?: string;
  inTimeDevice?: string;
  inGeolocation: string;
  outDateTime: string;
  outTimeSource?: string;
  outTimeDevice?: string;
  outGeolocation: string;
  isUserApproved: boolean;
  update: boolean;
  edits: any[];
  isDeleted: boolean;
}

export interface PunchListInterface extends PunchInterface {
  isValid: boolean;
  preset: string;
  display: { inDateTime: string; outDateTime: string };
  elapsed: string;
  dayTotal: string[];
  localApproved: boolean;
  showDetail: boolean;
}

export interface ValidatePunchTimesInterface {
  id: number;
  clientId: number;
  punchType: string;
  inDateTime: string;
  outDateTime: string;
  systemTime: number;
}

export type LastPunchAction = 'Clock Out' | 'Clock In';
export interface LastPunchInterface {
  clientId: number;
  action: LastPunchAction;
  status: string;
  label: string;
  bunit: string;
  projectId: string;
  in: string;
  out: string;
  closed: boolean;
  approved: boolean;
}

export interface NoticeInterface {
  id: number;
  label: string;
  title: string;
  message: string;
  level: string;
  dismissed: boolean;
  start: string;
  expiration: string;
  update?: boolean;
}
export interface TimesheetInterface {
  periodNumber: number;
  closed: boolean;
  punches: [];
  dailyHours: [
    {
      date: string;
      hours: number;
      time?: string;
    },
  ];
  workOrderHours: [
    {
      workOrderName: string;
      hours: number;
    }
  ];
  holidayHours: number;
  vacationHours: number;
  sickTimeHours: number;
  hoursWorked: number;
  totalHours: number;
  overtime: number;
  allApproved: boolean;
}

export interface TimesheetPeriodInterface {
  dateFrom: string;
  dateTo: string;
  periodName: string;
  periodNumber: number;
  periodType: string;
  status: string;
  closed: boolean;
}

export interface BusinessUnitInterface {
  name: string;
  locations: string[];
  projects: string[];
}

export interface Project {
  id: string;
  name: string;
  businessUnit: string;
  costCenter: string;
}

export interface ProjectsListItem {
  id: string;
  label: string;
  desc: string;
  businessUnit: string;
  costCenter: string;
  visible: boolean;
  selected: boolean;
}

// ** 3/2026 - project, userPin & subjectId can be removed in the future
// ** and also remove relevant code in storage.service, reshapePresets method
export interface UserPresetsDataInterface {
  value: string;
  name: string;
  businessUnit: string;
  costCenter: string;
  projectId: string;
  project?: string;// can be removed in the future
}

export interface UserPresetsInterface {
  value: string;
  data: UserPresetsDataInterface[];
  timeStamp: string;
  userPin?: number;// can be removed in the future
  subjectId?: string;// can be removed in the future
}

export interface KioskUserInterface {
  subjectId: string;
  name: string;
  resno: string;
  pinSet: boolean;
  // An expired session is still listed, so the user can be sent to renew it
  // rather than vanishing from the kiosk. Only a sign-in through the auth
  // provider renews it; a PIN sign-in never does.
  expired: boolean;
  expiresAt: string | null;
}

export type KioskSignInResult = 'signed-in' | 'expired' | 'failed';

export interface KioskDataInterface {
  userData: {
    entity: EntityInterface;
    presets: UserPresetsInterface;
    pdata: {
      periodNumber: number;
      closed: boolean;
      punches: PunchInterface[];
    };
    token: string;
  }[];
  periods: TimesheetPeriodInterface[];
  projects: Project[];
}

export interface ClientInfoInterface<D> {
  subjectId: string;
  resno: string;
  version: string;
  metadata: D
}
